<template>
    <div v-if="$store.state.connected" class="holidays">
        <h1>Saisie des jours feriés</h1>
      <HolidaysC />
    </div>
</template>

<script>
    import HolidaysC from "@/components/Holidays/Holidays.vue"
    import router from "../router/index.js";

    export default {
        name: "Holidays",
        components: {
            HolidaysC,
        },
        data(){
            return{
            }
        },
        created: function() {
            if (!this.$store.state.connected) {
                router.push('connexion');
            } 
        }
    };
</script>

<style></style>